import { useAjax } from "~/composables/useAjax";
import { EcomService } from "~/services/ecom.service";
import { AppCookieNames } from "../assets/constants/ecomApi";
import { useNuxtApp } from "#app";

export const useAjaxEcom = async <T>(
  url: string,
  options?: {
    params?: object;
    method?: "get" | "post" | "put" | "patch" | "delete";
    query?: object;
    headers?: object;
    show_notifications?: boolean;
    show_loading_indicator?: boolean;
    severity?: string;
    debug?: boolean;
    cache?: boolean;
    ttl?: number;
  },
  callback = null,
  retries = 4
) => {
  try {
    if (!options) {
      options = {};
    }
    const config = useRuntimeConfig();
    const public_config = config.public;

    let key = url;
    if (options.query) {
      key = key + JSON.stringify(options.query);
    } else if (options.params) {
      key = key + JSON.stringify(options.params);
    }

    key = key+'-'+public_config.appEnvironment+'-'+public_config.version+'-'+public_config.appRegion;

    const nuxtApp = useNuxtApp();

    if (!("show_notifications" in options)) {
      options.show_notifications = false;
    }

    if (!("debug" in options)) {
      options.debug = true;
    }
    if (!options.headers) {
      options.headers = {};
    }

    const authStore = useAuthStore();
    if(!options.headers["X-Toolstation-Customer-Id"]){

       if (authStore.guest && authStore.guest.token) {
        options.headers["X-Toolstation-Customer-Id"] = useAuthStore().guest.token;
      } else if (authStore.user && authStore.user.token) {
        options.headers["X-Toolstation-Customer-Id"] = useAuthStore().user.token;
      }
    }

    const i18n = { global: nuxtApp.$i18n };

    options.headers['Accept-Language'] = i18n.global.locale.value;

    if(process.server){
      options.headers['User-Agent'] = `Toolstation EU24-Web ${public_config.appEnvironment}-${public_config.version}-${public_config.appRegion}`;
    }

    let base_url = process.server && config.ecomApiBaseUrlServer ? config.ecomApiBaseUrlServer : public_config.ecomApiBaseUrl;

    let ecom_url = base_url + url;

    if((process.server && !config.ecomApiBaseUrlServer) || process.client){
      const accessTokenData = await EcomService.getAccessToken();

      options.headers.authorization = `Bearer ${accessTokenData.accessToken}`;
    }

    if (process.server && options.cache && nuxtApp.$redis && nuxtApp.$redis.status === 'ready') {
        const data = await EcomService.getRedisDataByKey(nuxtApp.$redis,key);
        if(data){
          const parsedData = JSON.parse(data);
          if(parsedData && (parsedData.length > 0 || (typeof parsedData === 'object' && Object.keys(parsedData).length > 0))){
            return parsedData;
          }
        }
    }

    let response = await useAjax<T>(ecom_url, options, callback);

    if (process.client && response && response.success === false && response.data &&
        response.data.error && response.data.error.code && response.data.error.code.includes('401.') &&
        response.data.error.message === AppCookieNames.EcomApiTokenErrorMessage && retries === 4) {

        retries--;
        const { EcomService } = await import("~/services/ecom.service");
        await EcomService.refreshToken();
        return useAjaxEcom(url,options,callback,retries)
    }

    if(response && response.success !== false && options.cache && nuxtApp.$redis && nuxtApp.$redis.status === 'ready'){
      if(!options.ttl){
        options.ttl = 90
      }
      nuxtApp.$redis.set(key,JSON.stringify(response), "EX", options.ttl);
    }

    return response;
  } catch (error) {
      console.log("[useAjaxEcomError]",error.message);
      console.log("[useAjaxEcomError]",error);

    return {
      success: false,
      errors: error.message,
    };
  }
};